import {intersection, difference, pick, keys, each} from "lodash";


//Note ignores target - assumes targets are all the same
// & the result will be attached to target

const Role = {
    getDiff: function getDiff(newRoles, oldRoles)
    {
        oldRoles = oldRoles || [];
        newRoles = newRoles || [];

        const oldLookup = this.getLookup(oldRoles);
        const newLookup = this.getLookup(newRoles);
        const oldList = keys(oldLookup);
        const newList = keys(newLookup);
        const diff = [];

        function addChange(role,action)
        {
            //const update = _.clone(role);
            const update = pick(role,['sourceType', 'sourceId', 'userPrivilege']);
            update.changeType = action.toUpperCase();
            diff.push(update);
        }

        each( intersection(oldList,newList), function(key)
        {
            if (oldLookup[key].userPrivilege !== newLookup[key].userPrivilege)
            {
                addChange(oldLookup[key],'delete');
                addChange(newLookup[key],'add');
            }
        });

        each( difference(oldList,newList), function(key)
        {
            addChange(oldLookup[key],'delete');
        });

        each( difference(newList,oldList), function(key)
        {
            addChange(newLookup[key],'add');
        });

        return diff;
    },

    getLookup: function(roles)
    {
        const lookup = {};
        each(roles, function(role)
        {
            lookup[role.sourceType + '_'+role.sourceId] = role;
        });
        return lookup;
    }
};

export default Role;
